import { Control } from "UI/UI.BaseControls/Control";
import { EditableControl } from "../../../../../UI.BaseControls/EditableControl";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";

export class MultiValueEdit extends EditableControl {
    protected override _innerElement: HTMLInputElement;

    //#region Properties
    public override set value(val: any) {
        this._innerElement.value = val;
    }

    public override get value(): any {
        return this._getValue().join(", ");
    }

    public set maxLength(val: number) {
        if (val && val > 0)
            this._innerElement.maxLength = val;
    }

    public get maxLength(): number {
        return this._innerElement.maxLength;
    }

    //#region controlValue
    public get controlValue(): string {
        return this._innerElement.value;
    }

    /**
     * Nastavi hodnotu editu
     */
    public set controlValue(value: string) {
        const el = this._innerElement;

        if (this.maxLength > 0 && value && value.length > this.maxLength) {
            el.value = value.substr(0, this.maxLength);
            //this.alertOnLength();
        } else {
            el.value = value;
        }
        //this.Validate(el);
    }
    //#endregion controlValue
    //#endregion Properties

    private _getValue(): Array<string> {
        const originalValue = this._innerElement.value;
        const finalValueList: string[] = [];
        const baseValues = originalValue.replace(/\s/ig, "").split(";");

        const f_parseList = (val: string) => {
            const s = val.split("-");
            if (s.length < 2)
                return;
            const startIndex = parseInt(s[0]);
            const endIndex = parseInt(s[1]);

            if (isNaN(startIndex) || isNaN(endIndex))
                return;

            if (startIndex > endIndex) {
                for (let i = endIndex; i <= startIndex; i++) {
                    finalValueList.push(i.toString());
                }
            } else {
                for (let i = startIndex; i <= endIndex; i++) {
                    finalValueList.push(i.toString());
                }
            }
        };
        for (const val of baseValues) {
            if (val) {
                if (/^[0-9]+\s*-\s*\d+$/.test(val))
                    f_parseList(val);
                else {
                    const s = parseInt(val);
                    if (isNaN(s))
                        continue;
                    finalValueList.push(s.toString());
                }
            }
        }

        return finalValueList;
    }

    public override focus(): void {
        this._innerElement.focus();
    }

    protected override _constructor(): void {
        super._constructor();

        const tcont: string = this.textContent.trim();
        this.innerHTML = "";

        this._innerElement = createElement({ type: "input" }) as HTMLInputElement;
        this.appendChild(this._innerElement);
        this.classList.add("Edit");

        if (tcont.length > 0) {
            this.value = tcont;
        }
    }

    protected override connectedCallback(): void {
        super.connectedCallback();

        if (this._innerElement) {
            Control.registerEventListener(this._eventGroup, this._innerElement, "change", (e) => {
                e.stopPropagation();
                this.callEvent("change");
            });
        }
    }
}

registerCustomElement("tsc-MultiValueEdit", MultiValueEdit);
